import { useCallback } from "react";
import { Link } from "react-router-dom";
import { m5Api } from "../../../api/m5";
import { PageHeader } from "../../../components/ComingSoon";
import { LoadState, useLoad } from "../shared";

export default function AdminElections() {
  const { data, error } = useLoad(useCallback(() => m5Api.elections(), []));
  return (
    <div data-testid="admin-elections-page" className="animate-rise space-y-6">
      <PageHeader title="Payment Methods" />
      <p className="max-w-3xl rounded-sm border border-amber-500/30 bg-amber-500/5 p-4 text-xs text-amber-100" data-testid="elections-nevada-help">{data?.nevada_help ?? "…"} No transfers are made by this app — payments are sent manually.</p>
      <LoadState error={error} loading={!data && !error} testId="elections-load" />
      <table className="w-full text-left text-sm text-zinc-300" data-testid="elections-table">
        <thead><tr className="label-caps text-zinc-500">{["Employee", "Method", "Recipient", "Status"].map((h) => <th key={h} className="py-2 font-normal">{h}</th>)}</tr></thead>
        <tbody>
          {data?.items.map((r) => (
            <tr key={r.employee_id} className="border-t border-white/5" data-testid={`election-row-${r.employee_id}`}>
              <td className="py-2"><Link to={`/admin/payment-elections/${r.employee_id}`} className="text-white hover:text-signal" data-testid={`election-open-${r.employee_id}`}>{r.employee_name}</Link></td>
              <td>{r.default ? r.label : r.method}</td>
              <td className="font-mono text-xs">{r.recipient_masked ?? "—"}</td>
              <td>{r.pending_second_admin ? <span className="text-amber-300">Pending second admin</span> : r.on_hold ? <span className="text-red-300">RECIPIENT_CHANGE_HOLD</span> : <span className="text-emerald-300">OK</span>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
